import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import {
    Component,
    Inject,
    ViewEncapsulation,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HippoConfirmationConfig } from '@hippo/services/confirmation/confirmation.types';

@Component({
    selector: 'hippo-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .hippo-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
            .hippo-confirmation__title {
                background-color: #001432;
                color: #ffffff;
                font-size: 1.25rem;
                font-weight: 500;
                line-height: 1.5rem;
                padding: 1rem;
            }
            .hippo-confirmation-dialog--soft {
                .hippo-confirmation__title {
                    background-color: var(--hippo-line);
                    border-bottom: 1px solid var(--hippo-navy);
                    color: var(--hippo-navy);
                    font-size: 17px;
                    font-weight: 600;
                    line-height: 24px;
                    padding: 16px 64px 16px 24px;
                }

                .hippo-confirmation__close {
                    --mat-icon-button-icon-color: var(--hippo-navy);
                    margin-top: -8px;

                    .mat-icon {
                        color: var(--hippo-navy) !important;
                    }
                }

                .hippo-confirmation__title--icon {
                    padding-bottom: 12px;
                    padding-top: 12px;
                }

                .hippo-confirmation__body--aligned {
                    padding-left: 68px;
                }
            }
            .hippo-confirmation__title--icon {
                align-items: center;
                display: flex;
                gap: 12px;
            }
            .hippo-confirmation__title-icon {
                align-items: center;
                border-radius: 999px;
                display: inline-flex;
                flex: 0 0 auto;
                height: 32px;
                justify-content: center;
                width: 32px;
            }
            .hippo-confirmation__body--aligned {
                padding: 20px 32px 24px 60px;
            }
            .hippo-confirmation-dialog-panel-small {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    zoom: 50% !important;
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        NgClass,
        CdkDrag,
        CdkDragHandle,
    ],
})
export class HippoConfirmationDialogComponent {
    private readonly iconColors: Record<string, string> = {
        primary:
            'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600',
        accent: 'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600',
        warn: 'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600',
        basic: 'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600',
        info: 'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600',
        success:
            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500',
        warning:
            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500',
        error: 'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600',
    };

    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: HippoConfirmationConfig
    ) {}

    get iconColor(): string {
        return this.iconColors[this.data.icon?.color ?? ''] ?? '';
    }

    get iconInTitle(): boolean {
        return (
            !!this.data.title &&
            !!this.data.icon?.show &&
            !!this.data.icon?.inTitle
        );
    }
}
